<div class="period-popup">
    <div class="popup-header">
        <h1>{{ data.title | translate }}</h1>
        <div *ngIf="!data.required" (click)="dialogRef.close()" class="clear-icon"></div>
    </div>
    <mat-dialog-content>
        <form autocomplete="off">
            <div class="popup-body">
                <div class="radio-btn-group">
                    <label>{{ data.label | translate }}</label>
                    <mat-radio-group [formControl]="recipientControl">
                        <mat-radio-button *ngFor="let item of data.recipients" [value]="item.Id">{{
                            item.Name
                        }}</mat-radio-button>

                        <mat-error
                            *ngIf="recipientControl.errors?.required && recipientControl.touched"
                        >
                            {{ 'errorText.emptyError' | translate }}
                        </mat-error>
                        <mat-error
                            *ngIf="
                                recipientControl.errors?.differentValue && recipientControl.touched
                            "
                        >
                            {{ 'errorText.differentValue' | translate }}
                        </mat-error>
                    </mat-radio-group>
                </div>
            </div>
        </form>

        <h3 *ngIf="!data.required">{{ 'nav.changeRecipientInfo' | translate }}</h3>
    </mat-dialog-content>

    <mat-dialog-actions align="start" class="contract-popup-buttons">
        <div class="action-bottom-buttons">
            <button (click)="submit()" class="btn green" type="button">
                {{ 'actions.save' | translate }}
            </button>
            <button
                *ngIf="!data.required"
                (click)="dialogRef.close()"
                class="btn blue"
                type="button"
            >
                {{ 'actions.cancel' | translate }}
            </button>
        </div>
    </mat-dialog-actions>
</div>
